<template>
    <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4" style="min-height: 800px; height: auto; overflow:auto">
        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <div class="h4">已购课程</div>
            <div class="btn-toolbar mb-2 mb-md-0">
                <div class="btn-group me-2">
                </div>
            </div>
        </div>
        <!-- 这里可以放东西 -->
        <div class="body">
            <!-- <span style="font-size:16px; font-weight: 600;">
                当前题库一共：
                <span style="color:red"> {{ this.$store.state.problem.question.length }} </span> 
                道题
            </span>
            <div style="float: right; margin-right:50px">

            </div> -->
            <!-- <div style="margin-right:50pxmargin-bottom: 5px;">
                <el-input
                placeholder="按照课程昵称搜索"
                v-model="input"
                clearable
                @keyup.native.enter="SearchUser">
                </el-input>
            </div> -->
            <el-table
            v-loading="loading"
            :data="list"
            border
            style="width: 1280px; margin: 0 auto;"
            min-height="200"
            max-height="500">
                <el-table-column
                    prop="name"
                    label="课程名称"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="total"
                    label="课程价格"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="payTime"
                    label="购买时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="orderId"
                    label="交易订单号"
                    width="270">
                </el-table-column>
                <el-table-column
                    prop="alipayNo"
                    label="支付宝交易号"
                    width="270">
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="233">
                    <template slot-scope="scope">
                    <el-button @click="GoUser(scope.row)" type="text" size="big">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </main>
    
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'
    export default {
        name:'Manage',
        data() {
            return {
                /* 题库修改部分 */
                currentPage3: 1, // 分页
                showpage:[], // 题库数组
                /* 这里是修改题目信息的地方 */

                list:[],
                loading: true,
            }
        },
        mounted() {
            setTimeout(() => {
                this.ReadMyOrders()
            }, 400)
            
        },
        methods: {
            ReadMyOrders() {
                const vue = this
                const store = this.$store
                $.ajax({
                    url: Url.rOneOrdersUrl,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            vue.list = JSON.parse(resp.list)
                        }
                        vue.loading = false
                    }
                })
            },
            GoUser(item) {
                this.$router.push(`/programmes/${item.goodsId}`)
            }
        }
    }
</script>

<style scoped>
.body {
    width: 1180px;
    min-height:165px;
    height: auto;
    margin:0 auto;
    background-color: white;
    padding: 20.8px;
    border-radius: 5px;
    box-sizing: border-box;
    border:2px solid lightgrey;
}
.demonstration {
    display: block;
    color: #8492a6;
    font-size: 15px;
}
</style>